import { Moment } from 'moment';
import { HandshakeStatus } from '../enums/HandshakeStatus';

export abstract class Handshake {
  constructor(
    private readonly id: number,
    private readonly initiatorIp: string,
    private readonly targetIp: string,
    private readonly initiatorPort: number | null,
    private readonly targetPort: number | null,
    private readonly timestamp: Moment | null,
    private readonly status: HandshakeStatus
  ) {}

  getId() {
    return this.id;
  }

  getInitiatorIp() {
    return this.initiatorIp;
  }

  getTargetIp() {
    return this.targetIp;
  }

  getInitiatorPort() {
    return this.initiatorPort;
  }

  getTargetPort() {
    return this.targetPort;
  }

  getTimestamp() {
    return this.timestamp;
  }

  getStatus() {
    return this.status;
  }
}
